import { render, staticRenderFns } from "./OuterBeforeInnerAfter.vue?vue&type=template&id=c1b81cf4&scoped=true"
import script from "./OuterBeforeInnerAfter.vue?vue&type=script&lang=js"
export * from "./OuterBeforeInnerAfter.vue?vue&type=script&lang=js"
import style0 from "./OuterBeforeInnerAfter.vue?vue&type=style&index=0&id=c1b81cf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b81cf4",
  null
  
)

export default component.exports